import { ServerConfig } from "@/config/config";
import { Module } from "@/models/module";
import { Axios } from "@/services/auth-service";

export class ModuleServiceClass{
	modules: Module[] = []
	private readonly baseUrl:string = ServerConfig.host + "/admin/modules";

	async getModules():Promise<Module[]> {
		let result = await Axios.get(this.baseUrl);
		this.modules = (result.data as any[]).map(d => new Module(d));
		return this.modules;
	}

	async createModule(mod:Module):Promise<any> {
		let result = await Axios.post(this.baseUrl, mod.getJSON());
		mod = new Module(result.data);
		this.modules.push(mod);
	}

	async updateModule(mod:Module):Promise<any> {
		let result = await Axios.put(`${this.baseUrl}/${mod.id}`, mod.getJSON());
		mod = new Module(result.data);
		let i = this.modules.findIndex(m => m.id == mod.id);
		this.modules[i] = mod;
	}

	async deleteModule(mod:Module):Promise<void> {
		await Axios.delete(`${this.baseUrl}/${mod.id}`);
	}
};

export const ModuleService = new ModuleServiceClass();